<template>
    <BCard class="mb-3 border-info shadow-sm">
        <template #header>
            <h5 class="mb-0 text-info font-weight-bold text-left">3. Fees & Costs</h5>
        </template>
        <BTabs content-class="mt-3" fill>
            <BTab title="Entrance Fees" active>
                <SpjEntranceFeeTab />
            </BTab>
            <BTab title="Parking Fees">
                <SpjParkingFeeTab />
            </BTab>
            <BTab title="Hotel Fees">
                <SpjHotelFeeTab />
            </BTab>
            <BTab title="Other Fees">
                <SpjOtherFeeTab />
            </BTab>
        </BTabs>
    </BCard>
</template>

<script setup>
import { BTabs, BTab, BCard } from "bootstrap-vue-next";

// Fees Tabs
import SpjEntranceFeeTab from "../tabs/SpjEntranceFeeTab.vue";
import SpjParkingFeeTab from "../tabs/SpjParkingFeeTab.vue";
import SpjOtherFeeTab from "../tabs/SpjOtherFeeTab.vue";
import SpjHotelFeeTab from "../tabs/SpjHotelFeeTab.vue";
</script>
